module.exports = __webpack_public_path__ + "img/cropper-example001.1aae4f89.png";